module.exports = __webpack_public_path__ + "img/dash-profile.2c71146c.png";